import { useMutation, useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { getPrivateAxiosInstance } from '../../../axiosInstances/axiosPrivate';
import { AcademiaResponse } from '../../../types/common';
import { Role, RoleReqBody } from '../../../types/roles';
import { returnQueryConfig } from '../../../utils/commonFunctions';

const useRolesActions = (whichAction: 'roleList' | '') => {
  // query function to fetch all the roles from the database declared here
  const getRoleListHandler = useQuery({
    queryKey: ['role-list'],
    queryFn: async (): Promise<AcademiaResponse<Array<Role>>> => {
      const response = await getPrivateAxiosInstance('user').get('/role/list/');

      return response.data;
    },

    ...returnQueryConfig(whichAction === 'roleList'),
  });

  // mutation function to create new role declared here
  const createNewRoleHandler = useMutation({
    mutationFn: async ({
      body,
    }: {
      body: RoleReqBody;
    }): Promise<AcademiaResponse<Role>> => {
      const response = await getPrivateAxiosInstance('user').post(
        '/role/create/',
        body
      );

      return response.data;
    },
  });

  // mutation function to update existing role declared here
  const updateRoleHandler = useMutation({
    mutationFn: async ({
      roleId,
      body,
    }: {
      roleId: number;
      body: RoleReqBody;
    }): Promise<AcademiaResponse<Role>> => {
      const response = await getPrivateAxiosInstance('user').patch(
        `/role/${roleId}/partial/update/`,
        body
      );

      return response.data;
    },
  });

  // mutation function to delete role declared here
  const deleteRoleHandler = useMutation({
    mutationFn: ({
      roleId,
    }: {
      roleId: number;
    }): Promise<AxiosResponse<AcademiaResponse<null>>> =>
      getPrivateAxiosInstance('user').delete(`/role/${roleId}/delete/`),
  });

  return {
    getRoleListHandler,
    createNewRoleHandler,
    updateRoleHandler,
    deleteRoleHandler,
  };
};

export default useRolesActions;
